// Import necessary dependencies
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {Accordion} from '../../components/Accordian';
import { FileUpload } from '../../components/FileUpload';
import toast from 'react-hot-toast';
import { Forbidden } from 'iconsax-react';
import { useAuthState } from "react-firebase-hooks/auth";
import {useNavigate} from 'react-router-dom';
import { auth, firestore } from "../../firebase";
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getPendingBookings, getUserData, getSurgeries } from '../../utils/FirebaseFunctions';
import { LoadingCards } from '../../components/LoadingCards';

const storage = getStorage();

const uploadFileToStorage = async (file, folder) => {
  const storageRef = ref(storage, `${folder}/${file.name}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
};

// Surgery component
const Surgery = () => {
  // Get the id from route params using useParams

  const [surgeriesData, setSurgeriesData] = useState([]);

  useEffect(() => {
    getSurgeries().then((data) => {
      setSurgeriesData(data);
    });
  }, [])

  const { id } = useParams();

  console.log(id, surgeriesData)

  const [showBooking, setShowBooking] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedPassport, setSelectedPassport] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [surgery, setSurgery] = useState(null);
  const [loading, setLoading] = useState(false);
  const [unselectedItems, setUnselectedItems] = useState("");

  const [user, userLoading] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading === false && user == null) {
      // Redirect to the login page if the user is not logged in
      navigate('/login');
    }

    if (user && userLoading === false) {
      getPendingBookings(user.uid).then((bookings) => {
        console.log(bookings)
      }).catch(err => {
        console.log(err)
      })
    }
    
  }, [user, userLoading]);


  const FAQs = [
    {
      title: "How do I book a surgery?",
      content: "You can book a surgery by clicking on the Book button and filling in the details.",
    }, {
      title: "What is the booking amount?",
      content: `The booking amount is $ ${surgery?.price} USD. The booking amount will be deducted from the total amount of the surgery. The booking amount is non-refundable.`,
    }, {
      title: "What are the required documents?",
      content: "You have to upload the following a few items and make the booking amount of $35 USD. The booking amount will be deducted from the total amount of the surgery. The booking amount is non-refundable.",
    },
    {
      title: "Why you have different prices for hospitals?",
      content: "The prices might vary a little based on the hospital and the doctor. The final price will be confirmed by the admin before hand.",
    },
    {
      title: "When can I get the final price?",
      content: "The final price will be confirmed by the admin before within 7 working days.",
    },
    {
      title: "What if I want to cancel the surgery?",
      content: "You can cancel the surgery before the final price is confirmed by the admin without a cancellation fee. Once the final price is confirmed, you will have to pay 24% as the cancellation fee. The refund for the ticket charges will depend on the airline policy.", 
    },
    {
      title: "What if I want to change the date of the surgery?",
      content:"You can change the date of the surgery before the final price is confirmed by the admin without a cancellation / reschedule fee. Once the final price is confirmed, you will have to pay 8% as the convinience fee. The refund / additional charge for the ticket will depend on the airline policy.",
    }
  ]

  useEffect(() => {
    const fetchData = async () => {
      const response = surgeriesData.find(item => item.id === id);
      setSurgery(response);
    };
    fetchData();
  }, []);

  const handleBooking = () => {
    setShowBooking(true);
  };

  const handleFileUpload = (files) => {
    setSelectedFile(files[0]);
  };

  const handlePassportUpload = (files) => {
    setSelectedPassport(files[0]);
  };


  const checkOut = async () => {
    try {
      let status = true;
      let notSelected = [];
      setLoading(true);
      if (!selectedDate) {
        status = false;
        notSelected.push('Date of Journey');
      }
      if (new Date().toISOString().split('T')[0] > selectedDate) {
        status = false;
        notSelected.push('Date of Journey');
      }
      if (!selectedFile) {
        status = false;
        notSelected.push('Medical Documents');
      }
      if (!selectedPassport) {
        status = false;
        notSelected.push('Passport');
      }
  
      if (status) {
        const [fileURL, passportURL] = await Promise.all([
          uploadFileToStorage(selectedFile, 'medical-documents'),
          uploadFileToStorage(selectedPassport, 'passports'),
        ]);

        const userData = {};
        await getUserData(auth.currentUser.uid).then((data) => {
          userData.name = data[0]?.name;
          userData.email = data[0]?.email;
          userData.phoneNumber = data[0]?.phoneNumber;
        });

        // Create a booking object with the required fields
        const bookingData = {
          uid: auth.currentUser.uid, // Assuming you have authenticated user
          timestamp: serverTimestamp(),
          surgeryID: parseInt(id, 10),
          status: 'paymentPending',
          medicalDocumentsURL: fileURL,
          surgeryName: surgery.name,
          passportURL,
          doj: selectedDate,
          userData
        };
  
        // Add the booking document to the "bookings" collection
        const docRef = await addDoc(collection(firestore, 'bookings'), bookingData);

        const metadata = {
          bookingID: docRef.id, 
          surgeryID: id,
        };
  
        toast.success('Redirecting to payment gateway', { duration: 4000, position: 'bottom-center' });
        setTimeout(() => {
          window.location.href = `https://book.stripe.com/test_fZeaEObAt88Bere8ww?${new URLSearchParams(metadata)}`;
        }, 1000);
      } else {
        toast.error('Please fill ' + notSelected, { duration: 4000, position: 'bottom-center' });
        setUnselectedItems(notSelected.join(', '));
      }
    } catch (error) {
      console.error('Error creating booking:', error);
      // Handle the error here, you might want to notify the user
      toast.error('Error creating booking', { duration: 4000, position: 'bottom-center' });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2500);
    }
  };

  useEffect(() => {
    let notSelected = []
    if(!selectedDate) {
      notSelected.push("Date of Journey")
    }
    if(new Date().toISOString().split('T')[0] > selectedDate) {
      notSelected.push("Date of Journey")
    }
    if(!selectedFile) {
      notSelected.push("Medical Documents")
    } 
    if(!selectedPassport) {
      notSelected.push("Passport")
    }
    setUnselectedItems(notSelected.join(", "))
  }, [
    selectedFile, selectedDate, selectedPassport
  ])

  return (
    <div className='z-1'>
      {surgery && <div className='w-screen p-5'>
        <div className='min-h-[200px] h-auto p-5 mt-8 bg-white rounded-lg mb-8 w-full'>
          <img src={surgery?.image} className='w-full rounded-lg h-full' alt="" />
        </div>
        <p className='text-sm font-bold mt-[25px] mb-[25px]'>Details</p>
        <div className='w-full bg-white p-5 rounded-lg flex flex-col'>
          <h2 className='text-sm w-full flex flex-row mb-3'>Name <strong className='ml-auto'>{surgery?.name}</strong></h2>
          <h2 className='text-sm w-full flex flex-row mb-3'>Duration <strong className='ml-auto'>{surgery?.duration + " Days"}</strong></h2>
          <h2 className='text-sm w-full flex flex-row mb-3'>Price <strong className='ml-auto'>{surgery?.price + " USD"}</strong></h2>
          <h2 className='text-sm w-full flex flex-row mb-3'>Booking Amount <strong className='ml-auto'>{"40 USD"}</strong></h2>
        </div>
        <p className='text-sm font-bold mt-[35px] mb-[5px]'>FAQs</p>
        <div className='z-1'>
          <Accordion content={FAQs} />
        </div>

        <div className='w-full bg-white p-5 mt-[-15px] mb-[5px] rounded-lg flex flex-col'>
          <p className='text-sm font-bold mb-[25px]'>Please Note</p>
          <p className='text-sm'>
            1. &nbsp; You have to upload the following a few items and make the booking amount of <strong> &nbsp; {"$" + surgery?.price} USD. &nbsp; </strong> The booking amount will be deducted from the total amount of the surgery. The booking amount is non-refundable.  
            <br /> <br /> 2. &nbsp; There might be a few more documents required by the hospital. The hospital will contact you for the same.
            <br /> <br /> 3. &nbsp; The prices might vary a little based on the hospital and the doctor. The final price will be confirmed by the admin before hand.
          </p>
        </div>
        
        {!showBooking && <button onClick={handleBooking} className='bg-blue-500 w-full text-white py-3 px-4 mt-4 rounded'>
          Book
        </button>}
        {/* Inputs for booking */}
        {showBooking && (
          <>
            <p className='my-[25px] text-md'>Please fill in the following details</p>
            <input onChange={(e) => {
              setSelectedDate(e.target.value);
            }} min={new Date().toISOString().split('T')[0]} type="date" placeholder="Select Date of Journey" className=" w-full border border-dashed rounded-lg bg-gray-100 border-gray-400 p-4" />
            <FileUpload onFileUpload={handlePassportUpload} uploadText={"Upload your passport"} allowed={"image/*, application/pdf"} maxFiles={1} />
            <FileUpload onFileUpload={handleFileUpload} uploadText={"Upload your medical document"} allowed={"image/*, application/pdf"} maxFiles={1} />
            {unselectedItems && 
              <div className='flex flex-row items-center justify-center gap-[20px]'>
                <Forbidden
                  size="32"
                  color="red"
                  variant="TwoTone"
                />
                <p className='mt-[25px] mb-[10px] text-red-900'>{unselectedItems} should be submitted</p>
              </div>
            }
            <button onClick={checkOut} className={!loading ? 'bg-blue-500 w-full text-white py-3 px-4 mt-4 rounded' : "bg-blue-300 border-blue-500 border-2	 cursor-not-allowed w-full text-white py-3 px-4 mt-4 rounded"}>
              {loading ? "Redirecting ..." : "Pay Booking Amount"}
            </button>
          </>
        )}
        <div className='w-full h-[150px]'></div>
      </div>}
      {!surgery && <div className='w-screen h-[calc(100vh-350px)] p-5 mt-12 flex items-start justify-start'>
          <LoadingCards />
      </div>}
    </div>
  );
};

export default Surgery;
